package com.essntl.features.task.ui.addedittask.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.task.ui.addedittask.AddEditTaskEvent
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.features.task.ui.addedittask.AddEditTaskValidation
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.utils.spacing

@Composable
fun TaskOwnerSection(
    state: AddEditTaskState,
    validation: AddEditTaskValidation,
    onEvent: (AddEditTaskEvent) -> Unit,
    enabled: Boolean,
) {
    EsInputDropdownMenu(
        items = state.getAllProfile.data,
        selectedItem = state.task.value.owner,
        text = { owner ->
            owner.prettyName
        },
        onItemSelected = {
            validation.addEditTaskForm.owner.validate(it.id)
            onEvent(
                AddEditTaskEvent.UpdateTaskFields(
                    state.task.value.copy(
                        owner = it,
                    ),
                ),
            )
        },
        label = "Owner",
        placeholder = "Select owner",
        state = validation.addEditTaskForm.owner.state,
        message = validation.addEditTaskForm.owner.errorMessage ?: "This field is required",
        loading = state.getAllProfile.isLoading && state.getAllProfile.data.isEmpty(),
        enabled = enabled && !state.addEditTask.isLoading,
        modifier = Modifier.fillMaxWidth(),
    ) {
        if (!state.getAllProfile.isLastPage) {
            Spacer(modifier = Modifier.height(2.spacing))

            EsMediumOutlineButton(
                onClick = {
                    onEvent(AddEditTaskEvent.LoadMoreProfiles)
                },
                text = "Load more",
                loading = state.getAllProfile.isLoading,
                modifier = Modifier.align(Alignment.CenterHorizontally),
            )
        }
    }
}